module.exports = __webpack_public_path__ + "static/img/guide.b857ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/guide.png
// module id = SHK5
// module chunks = 1